import React from 'react';
import { Car, Award, Users } from 'lucide-react';
const TrustBadges = () => {
  return <section className="bg-gray-50 py-16" data-id="element-367">
      <div className="container mx-auto px-4" data-id="element-368">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-369">
          {/* Modern Automatic Vehicles */}
          <div className="flex flex-col items-center text-center" data-id="element-370">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-371">
              <Car size={32} className="text-blue-600" data-id="element-372" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-373">
              Modern Automatic Vehicles
            </h3>
            <p className="text-gray-700" data-id="element-374">
              Learn in our dual-controlled, air-conditioned automatic vehicles
              equipped with the latest safety features.
            </p>
          </div>
          {/* Qualified Instructors */}
          <div className="flex flex-col items-center text-center" data-id="element-375">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-376">
              <Award size={32} className="text-blue-600" data-id="element-377" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-378">Qualified Instructors</h3>
            <p className="text-gray-700" data-id="element-379">
              All our instructors are DVSA approved with years of experience and
              excellent pass rates.
            </p>
          </div>
          {/* Personalized Lessons */}
          <div className="flex flex-col items-center text-center" data-id="element-380">
            <div className="bg-blue-100 p-6 rounded-full mb-4" data-id="element-381">
              <Users size={32} className="text-blue-600" data-id="element-382" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-383">Personalised Lessons</h3>
            <p className="text-gray-700" data-id="element-384">
              We tailor our teaching methods to suit your learning style and
              help you progress at your own pace.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default TrustBadges;